import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  title: {
    id: 'studio.5zgvJw',
    defaultMessage: 'Add new members',
  },
  email: {
    id: 'studio.sy+pv5',
    defaultMessage: 'Email',
  },
  help: {
    id: 'studio.+xR2VI',
    defaultMessage:
      'Tabular data can be copied into the input field to add multiple people at once',
  },
  optional: {
    id: 'studio.InWqys',
    defaultMessage: 'Optional',
  },
  cancel: {
    id: 'studio.47FYwb',
    defaultMessage: 'Cancel',
  },
  submit: {
    id: 'studio.OCiHj6',
    defaultMessage: 'Add members',
  },
  error: {
    id: 'studio.+WXioK',
    defaultMessage: 'There was a problem inviting these new members.',
  },
  Member: {
    id: 'studio.7L86Z5',
    defaultMessage: 'Member',
  },
  AppTranslator: {
    id: 'studio.Vg+/cC',
    defaultMessage: 'AppTranslator',
  },
  AppContentsExplorer: {
    id: 'studio.vUOBIG',
    defaultMessage: 'AppContentsExplorer',
  },
  AppContentsManager: {
    id: 'studio.ebfZw6',
    defaultMessage: 'AppContentsManager',
  },
  AppMemberManager: {
    id: 'studio.7IeO4D',
    defaultMessage: 'AppMemberManager',
  },
  AppGroupManager: {
    id: 'studio.2Ai+M8',
    defaultMessage: 'AppGroupManager',
  },
  AppGroupMembersManager: {
    id: 'studio.im867P',
    defaultMessage: 'AppGroupMembersManager',
  },
  AppManager: {
    id: 'studio.o61GlD',
    defaultMessage: 'AppManager',
  },
  AppCollectionManager: {
    id: 'studio.VDt0tf',
    defaultMessage: 'AppCollectionManager',
  },
  BlockManager: {
    id: 'studio.xfR9j2',
    defaultMessage: 'BlockManager',
  },
  Maintainer: {
    id: 'studio.eXDZGQ',
    defaultMessage: 'Maintainer',
  },
  Owner: {
    id: 'studio.zINlao',
    defaultMessage: 'Owner',
  },
});
